import { InvokeFunctionExpr } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { AdminLocalStorageService } from '../shared/auth/admin-local-storage.service';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.less']
})
export class AuthComponent implements OnInit {

  private poolData = {
    UserPoolId: 'eu-central-1_rGl2reFjn', // Your user pool id here
    ClientId: '6dm9vd98ep65dtk2r3fgaipp2a', // Your client id here
    //ClientId: '1618k6g5bb22q4svsf1ef1nafa'
  };
  private cognitoUser :any = null;
  username :string = "";
  password :string = "";

  constructor(private localStorage: AdminLocalStorageService,
      private route : ActivatedRoute,
      private router : Router
    ) { 

  }

  ngOnInit(): void {
  }

  login() {

    let qparams = this.route.queryParams;
    let redirectURL = "/"
    qparams.forEach(params => {
      if (params.redirectURL) {
        redirectURL += params.redirectURL;
      }
    })

    let userPool = new CognitoUserPool(this.poolData);
    let userData = {
      Username: this.username,
      Pool: userPool,
    };
    let authenticationDetails = new AuthenticationDetails({
      Username: this.username,
      Password: this.password,
    });
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        console.log(result)
        console.log(result.getAccessToken());
        let jwtToken = result.getAccessToken().getJwtToken();
        this.localStorage.setToken(jwtToken)
        this.router.navigateByUrl(redirectURL)
          .catch(() => this.router.navigate(['homepage']))
      },
    
      onFailure: (err) => {
        alert(err.message || JSON.stringify(err));
      },
    });

  }

  isProduction() :boolean {
    return environment.production;
  }

  logout() {

  }

  info() {

    let userPool = new CognitoUserPool(this.poolData);
    let cognitoUser = userPool.getCurrentUser();  
    console.log(cognitoUser)
    // console.log(cognitoUser.storage.awsToken);
  }



  getUser(userName : string){
    if (this.cognitoUser===null){
          // var userPool = new CognitoUserPool(this.poolData);
          // var userData = {
          //     Username : userName,
          //     Pool : userPool
          //     };
          // this.cognitoUser = new CognitoUser(userData);
    }
    return this.cognitoUser;
  }

  // signInUser(userName: string, password:string) : Observable<any> {
  //     let authenticationData = {
  //         Username : userName,
  //         Password : password,
  //     };
  //     var authenticationDetails = new AuthenticationDetails(authenticationData);
  //     return new Observable<any>( (observer) => {
  //         this.getUser(userName).authenticateUser(authenticationDetails, {
  //             onFailure: (err)=>{
  //                 observer.error(err)
  //                 observer.complete();
  //             },
	// 	    onSuccess: (result)=>{
  //                 observer.next(result);
  //                 observer.complete();
  //             }
  //         });
  //     })
  // }


  // signOutUser() : Observable<any> {
  //     return new Observable<any>( (observer) => {
  //         if (this.cognitoUser != null){
  //             if (this.cognitoUser.getSignInUserSession() != null){
  //                 this.cognitoUser.signOut();
  //                 this.cognitoUser = null;
  //                 observer.next("User signed out");
  //                 observer.complete
  //                 return;
  //             }
  //         }	
  //         observer.error("User is not signed in")
  //     })
  // }



}
